/**
 * DOS518 - Digital Operations System for Wildfire Management
 * 
 * Copyright (c) 2024-2025 Angelo Irtilaç
 * All rights reserved.
 * 
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, modification, or use is strictly prohibited.
 * 
 * ---
 * 
 * Author: Angelo Irtilaç
 * Qualifications: DOS (Direttore delle Operazioni di Spegnimento)
 *                39 years - Corpo Nazionale dei Vigili del Fuoco
 *                DOS Trainer & Instructor
 * 
 * Location: Carpi, Italy
 * Contact: [inserire email]
 * 
 * ---
 * 
 * This software implements official Italian Fire Department protocols:
 * - C.O.A.U. (Centro Operativo Aereo Unificato)
 * - SI.TA.C. (Sistema Tattico di Coordinamento)
 * - L.A.C.E.S. (Lookout, Awareness, Communication, Escape routes, Safety zones)
 * 
 * Developed with operational expertise acquired through decades of wildfire
 * emergency management and coordination of suppression operations.
 * 
 * For commercial licensing inquiries, please contact the author.
 */
// src/components/common/SelectModal.tsx
import React from 'react';
import ReactDOM from 'react-dom';
import './SelectModal.css';

interface SelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  options: string[];
  onSelect: (value: string) => void;
  selectedValue?: string;
}

export const SelectModal: React.FC<SelectModalProps> = ({
  isOpen,
  onClose,
  title,
  options,
  onSelect,
  selectedValue,
}) => {
  if (!isOpen) return null;

  const handleSelect = (value: string) => {
    onSelect(value);
    onClose();
  };

  const modal = (
    <div className="select-modal-overlay" onClick={onClose}>
      <div className="select-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="select-modal-header">
          <h3>{title}</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="select-modal-body">
          {options.map((option, index) => (
            <button
              key={index}
              className={`select-option ${selectedValue === option ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {selectedValue === option && <span className="check-icon">✓</span>}
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};
